import React from 'react';
const WmLabel = _ref => {
  let {
    htmlFor,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("label", {
    id: props.id,
    className: props.noUpcase ? 'otto__label_no_up' : 'otto__label',
    htmlFor: htmlFor
  }, props.text);
};
WmLabel.defaultProps = {
  htmlFor: '',
  id: ''
};
export default WmLabel;